module.exports = __webpack_public_path__ + "~@/assets/img/dimon.b5ad93a7.png";